import { render, staticRenderFns } from "./CategoriesEdit.vue?vue&type=template&id=35b84476&scoped=true&"
import script from "./CategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./CategoriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b84476",
  null
  
)

export default component.exports